import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgClosed = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.75 22.75H23.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.25 9.25H0.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 6.25L13.2 1.85C13.0603 1.66371 12.8791 1.5125 12.6708 1.40836C12.4625 1.30422 12.2329 1.25 12 1.25C11.7671 1.25 11.5375 1.30422 11.3292 1.40836C11.1209 1.5125 10.9397 1.66371 10.8 1.85L7.5 6.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 12.25C2.95435 12.25 2.19129 12.5661 1.62868 13.1287C1.06607 13.6913 0.75 14.4544 0.75 15.25V16.75C0.75 17.5456 1.06607 18.3087 1.62868 18.8713C2.19129 19.4339 2.95435 19.75 3.75 19.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 12.25C10.8522 12.25 10.4706 12.408 10.1893 12.6893C9.90804 12.9706 9.75 13.3522 9.75 13.75V18.25C9.75 18.6478 9.90804 19.0294 10.1893 19.3107C10.4706 19.592 10.8522 19.75 11.25 19.75C11.6478 19.75 12.0294 19.592 12.3107 19.3107C12.592 19.0294 12.75 18.6478 12.75 18.25V13.75C12.75 13.3522 12.592 12.9706 12.3107 12.6893C12.0294 12.408 11.6478 12.25 11.25 12.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 12.25V18.25C5.25 18.6478 5.40804 19.0294 5.68934 19.3107C5.97064 19.592 6.35218 19.75 6.75 19.75H8.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 12.25H16.5C16.1022 12.25 15.7206 12.408 15.4393 12.6893C15.158 12.9706 15 13.3522 15 13.75C15 16 18 16 18 18.25C18 18.6478 17.842 19.0294 17.5607 19.3107C17.2794 19.592 16.8978 19.75 16.5 19.75H15"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.25 19.75H21.75C21.3522 19.75 20.9706 19.592 20.6893 19.3107C20.408 19.0294 20.25 18.6478 20.25 18.25V13.75C20.25 13.3522 20.408 12.9706 20.6893 12.6893C20.9706 12.408 21.3522 12.25 21.75 12.25H23.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.25 16.75H23.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgClosed.displayName = 'SvgClosed';
export default SvgClosed;
